import AdminStatusApi from './AdminStatusApi';

export default class AdminApi {
    constructor(dashApi) {
        this.DashAPI = dashApi;
        this.Status = new AdminStatusApi(dashApi);
        this._Status = AdminStatusApi;
    }
}



// WEBPACK FOOTER //
// ./src/DashApi/admin/AdminApi.js


// WEBPACK FOOTER //
// webpack:///src/DashApi/admin/AdminApi.js